import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HEADER_NAME_DONT_SAVE_REQ, HEADER_NAME_RESET_REQ } from '@app/constants';
import { AuthService } from '@app/services';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

   private cache: Map<string, HttpResponse<any>> = new Map();

   constructor(private authServ: AuthService) {
      this.authServ.cleanCacheInterceptor.subscribe(() => {
         this.cache = null;
         this.cache = new Map();
      });
   }

   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      this.authServ.initSessionTimer();
      this.authServ.updateExpirationTime();
      this.authServ.expirationWarnings.warning = false;

      /** Obtener header si no se requiere ser cacheado */
      const dontSaveReq = req.headers.get(HEADER_NAME_DONT_SAVE_REQ);

      // Cachear request OK
      if (!dontSaveReq) {
         /**
          * Nombre de request se conforma de la url completa (con parámetros) y el cuerpo hecho string
          ** Así se puede tener request de búsqueda cacheados por parámetros y no sólo por url
         */
         const urlWithParams = `${req.urlWithParams}${JSON.stringify(req.body)}`;

         // Se compara si tiene header de reseteo para borrar respuesta actual
         if (req.headers.get(HEADER_NAME_RESET_REQ)) {
            this.cache.delete(urlWithParams)
         }

         /** Respuesta de request cacheado */
         const cachedResponse: HttpResponse<any> | undefined = this.cache.get(urlWithParams);

         /** Validar si request se encuentra ya cacheado */
         if (cachedResponse) return of(cachedResponse.clone());

         return next.handle(req).pipe(
            tap(stateEvent => {
               if (stateEvent instanceof HttpResponse) {
                  this.cache.set(urlWithParams, stateEvent.clone())
               }
            })
         );

      }

      return next.handle(req);
   }
}
